var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loginfailed) ? _c('body', {
    staticClass: "loginpage",
    attrs: {
      "background": "static/img/banner.jpg"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "size": "60",
      "color": "#3ba9f3",
      "active": _vm.isSSOLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isSSOLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('section', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "app2 flex-row align-items-center"
  }, [(_vm.tokenid == '') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-9 col-lg-9 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card text-white py-3 d-md-down-none",
    staticStyle: {
      "width": "44%",
      "background-color": "#5eccfb9c !important"
    }
  }, [_c('img', {
    staticClass: "dark-logo",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "src": "static/img/logo.png",
      "alt": "homepage",
      "width": "40%"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8rem !important",
      "margin-left": "auto",
      "margin-right": "auto",
      "max-width": "830px"
    }
  }, [_c('h4', {
    staticClass: "login_title",
    staticStyle: {
      "max-width": "825 !important"
    }
  }, [_vm._v(_vm._s(_vm.loginfailedmsg))])]), _vm._v(" "), _vm._m(0)])])])])]) : _vm._e()])])], 1) : _vm._e()
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body text-center",
    staticStyle: {
      "margin": "0 auto",
      "max-width": "790px"
    }
  }, [_c('div', [_c('p', {
    staticClass: "xb_text"
  }, [_vm._v("Please contact support.")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4504e0a7","hasScoped":true}!./src/views/components/login/login.component.html
// module id = 526
// module chunks = 3